import api from '@/services/api'
import { METHOD, request} from '@/utils/request'

export const bigDataApi = {
    getDetail(id) {//获取详情
        return request(api.followRecord.DETAIL + "/" + id, METHOD.GET);
    },
    getDetailFollowRecord(id) {//获取跟进详情
        return request(api.followRecord.DETAIL_FOLLOW_RECORD + "/" + id, METHOD.GET);
    },
    async selection(params) {
        return request(api.visit.SELECT_DEPT, METHOD.GET, params)
    }
}

export default {bigDataApi}
